const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5056/api').replace(/\/$/, '');

async function request(path, { method = 'GET', body, token, query } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;

  const qs = query
    ? '?' + Object.entries(query).filter(([_, v]) => v !== undefined && v !== '').map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&')
    : '';

  const res = await fetch(`${API_BASE}${path}${qs}`, {
    method, headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.error?.message || `HTTP ${res.status}`);
    err.code = data?.error?.code || `HTTP_${res.status}`;
    err.status = res.status;
    throw err;
  }
  return data;
}

export const chantiersApi = {
  list:        (opts)        => request('/chantiers',                { query: opts }),
  get:         (id)          => request(`/chantiers/${id}`),
  adminList:   (token, opts) => request('/admin/chantiers',           { token, query: opts }),
  adminGet:    (token, id)   => request(`/admin/chantiers/${id}`,     { token }),
  adminCreate: (token, body) => request('/admin/chantiers',           { method: 'POST',   token, body }),
  adminUpdate: (token, id, b)=> request(`/admin/chantiers/${id}`,     { method: 'PATCH',  token, body: b }),
  adminDelete: (token, id)   => request(`/admin/chantiers/${id}`,     { method: 'DELETE', token }),
};

// Constantes partagées pour les UI
export const CHANTIER_STATUSES = [
  { id: 'all',          lbl: 'Tous statuts' },
  { id: 'en_cours',     lbl: 'En cours',     dot: 'live'  },
  { id: 'phase_finale', lbl: 'Phase finale', dot: 'warn'  },
  { id: 'planifie',     lbl: 'Planifié',     dot: 'plan'  },
  { id: 'suspendu',     lbl: 'Suspendu',     dot: 'muted' },
  { id: 'livre',        lbl: 'Livré',        dot: 'done'  },
];

export const CHANTIER_CATEGORIES = [
  { id: 'all',           lbl: 'Toutes catégories' },
  { id: 'voirie',        lbl: 'Voirie' },
  { id: 'education',     lbl: 'Éducation' },
  { id: 'environnement', lbl: 'Environnement' },
  { id: 'jeunesse',      lbl: 'Jeunesse' },
  { id: 'sport',         lbl: 'Sport' },
  { id: 'patrimoine',    lbl: 'Patrimoine' },
  { id: 'sante',         lbl: 'Santé' },
  { id: 'autre',         lbl: 'Autre' },
];

export const STATUS_LABEL = Object.fromEntries(CHANTIER_STATUSES.map((s) => [s.id, s.lbl]));
export const CATEGORY_LABEL = Object.fromEntries(CHANTIER_CATEGORIES.map((c) => [c.id, c.lbl]));
